export const LOCAL_STORAGE_FLOW = "dapp.flow"
export const LOCAL_STORAGE_COIN_GECKO = "dapp.coin_gecko"

// This variable should be indexed. When chaning the banner
// the variable should look like: new_assets_banner_visible[x] -> new_assets_banner_visible[x + 1]
export const LOCAL_STORAGE_NEW_ASSETS_BANNER_VISIBLE =
  "dapp.new_assets_banner_visible8"

export const LOCAL_STORAGE_MATS_MAIN_BANNER_VISIBLE = ((): string =>
  "dapp.points_main_banner_visible3")()

export const LOCAL_STORAGE_MIGRATIONS_SEEN = "dapp.migrations_seen"

export const LOCAL_STORAGE_BORROW_MATS_BANNER_VISIBLE =
  "dapp.borrow_mats_banner_visible"

export const LOCAL_STORAGE_CLAIM_STUFF_DISMISSED = "dapp.claim_stuff_dismissed"

export const LOCAL_STORAGE_MAINNET_WELCOME_MODAL_VISIBLE =
  "dapp.mainnet_welcome_modal_visible"

export const LOCAL_STORAGE_QA_MODE = "dapp.qa_mode"
